import '@babel/polyfill'
import 'mutationobserver-shim'

import Vue from 'vue'
import {
  BootstrapVue,
  BootstrapVueIcons,
  AvatarPlugin
} from 'bootstrap-vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from '../src/router/index.js'
import VueChatScroll from 'vue-chat-scroll'


Vue.use(VueChatScroll)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(AvatarPlugin)

Vue.config.productionTip = false
window.vue = new Vue({});


new Vue({

  router,
  render: h => h(App)
}).$mount('#app')